import { createAccountBaseRoute } from './baseAccountRoute'
import { sharedMarketingRoutes } from './sharedRoutes'
import { serviceDeskRoutes } from './serviceDeskRoutes'
import { commerceRoutes } from './commerceRoutes'

export const marketingRoutesForServiceDesk = [
  createAccountBaseRoute('MarketingServiceDesk', [
    ...serviceDeskRoutes,
    ...sharedMarketingRoutes,
  ]),
]

export const marketingRoutesForCommerce = [
  createAccountBaseRoute('MarketingCommerce', [
    ...commerceRoutes,
    ...sharedMarketingRoutes,
  ]),
]